module.exports = __webpack_public_path__ + "img/t2.35f9262b.jpg";